import React, { useState, useEffect } from "react";

// DevExtreme components
import { Slider } from 'devextreme-react/slider';

const EMPTY = undefined;

export function SliderWidget(props) {
  const { ui, data, config, writeBack } = props;
  const [localContent, setLocalContent] = useState(EMPTY);

  let widgetId = ui.id;
  let content = localContent !== EMPTY ? localContent : data && data.content ? parseFloat(data.content) : null;
  let disabled = ui.readonly || (data && data.readonly);
  let minValue = (config && config.Minimum) ? config.Minimum : 0;
  let maxValue = (config && config.Maximum) ? config.Maximum : 1000000;
  let steps = (config && config.Steps) ? config.Steps : 1;

  useEffect(() => {
    console.log("SliderWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const setContent = value => {
    setLocalContent(value);
    writeBack(value ? value.toString() : null, true);
  };

  return (
    <Slider
      id={widgetId}
      value={content}
      min={minValue}
      max={maxValue}
      step={steps}
      onValueChanged={e => setContent(e.value)}
      disabled={disabled}
      height={ui.controlHeight + "em"}
    />
  );
}
